module.exports = __webpack_public_path__ + "media/images/filing-0e9fd7689a33eb26878f13dcd56c7f8f.svg";